export enum DiskMountingState {
    MOUNTED, UNMOUNTED
}